import '../../jsscripts/jquery/date.js';

export function stringToDate(dateString, utcOffset, autoAdjust) {
    // http: //stackoverflow.com/questions/726334/asp-net-mvc-jsonresult-date-format
    // unfortunately no native support for dates in JSON, so we have to do this logic
    if (dateString === null || dateString === '' || dateString.indexOf('Date(') === -1) {
        return null;
    }

    var MILLISECONDS_PER_MINUTE = 60000,
        date = new Date(parseInt(dateString.replace('/Date(', '').replace(')/', ''), 10)),
        localUtcOffsetMilliseconds = date.getTimezoneOffset() * MILLISECONDS_PER_MINUTE,
        adjustment;

    if (utcOffset !== undefined && utcOffset) {
        adjustment = localUtcOffsetMilliseconds + utcOffset.TotalMilliseconds;
        date.addMilliseconds(adjustment);
    } else if (autoAdjust !== undefined && autoAdjust) {
        date.addMilliseconds(localUtcOffsetMilliseconds);
    }

    return date;
}
